import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Welcome from '../../../../assets/images/Welcome.png';
import { ImgWebp } from '../../ImgWeb';
import { ButtonClassNames, GlobalRouteNames, CookieItems } from '../../../../models/Common';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';

interface StartTourProps {
  handleProceed: (skip?: boolean) => void;
  handleClose: () => void;
  userId: number;
}

export const ProductTourStart: FC<StartTourProps> = ({ handleProceed, handleClose, userId }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { pathname } = useLocation();
  const [, setCookie] = useCookies();

  const setCookieAndCloseWindow = () => {
    setCookie(`${CookieItems.PRODUCT_TOUR}_${userId}`, userId, { path: '/', maxAge: 86400 * 90 });
    handleClose();
  };

  const handleSkip = () => {
    handleProceed(true);
    setCookieAndCloseWindow();
  };

  const handleStart = () => {
    if (pathname !== GlobalRouteNames.HomePage) {
      history.push(GlobalRouteNames.HomePage);
    }
    handleProceed();
    setCookieAndCloseWindow();
  };

  return (
    <div className="modals">
      <div className="modals__header" style={{ textAlign: 'center' }}>
        <article className="modals__header__title">{t('productTour.welcomeTitle')}</article>
        <p className="modals__header__description">{t('productTour.welcomeDescription')}</p>
        <ImgWebp fallback={Welcome} alt="welcome" className="img" />
      </div>
      <div className="modals__btn-group" style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
        <CustomMUIButton
          label={t('common.skip')}
          handleClick={handleSkip}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
        <CustomMUIButton
          label={t('productTour.startTour')}
          handleClick={handleStart}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
        />
      </div>
    </div>
  );
};
